// import dama from "/modules/dama.js";
// import apiDrupal from "./api.js";
// const dm = new dama();
import 'lazysizes';

// const api = new apiDrupal();
export const page = async () => {
    /* ON LOAD */
    const btnLogout = document.querySelector('.btn-close-session')
    const validLocal = localStorage.getItem('email');

    btnLogout && btnLogout.addEventListener('click', function(){
        localStorage.removeItem('email');
    })
    
    if(window.location.pathname == '/iniciar-sesion'){
        const form = document.getElementById('loginform'),
         emailValue:HTMLInputElement = form.querySelector('#edit-email'), 
         btnLogin = form.querySelector('#edit-submit')
         btnLogin && btnLogin.addEventListener('click', function(){
            localStorage.setItem('email', emailValue.value);

        })
    }

    if(window.location.pathname == '/trivia-mezclas'){
        if(!validLocal){
            location.href = '/trivia';
        }
    }
}